import { render, staticRenderFns } from "./ChatBoxFlex.vue?vue&type=template&id=6bfdd6bd&scoped=true&"
import script from "./ChatBoxFlex.vue?vue&type=script&lang=js&"
export * from "./ChatBoxFlex.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxFlex.vue?vue&type=style&index=0&id=6bfdd6bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdd6bd",
  null
  
)

export default component.exports